import React from "react";

const Background = ({ children }) => {
  return <div className="bg-gray-200 dark:bg-gray-800">{children}</div>;
};

export default Background;
